/**
 * Collection of constants for Custom Bundle Keys
 * such as Store Manager
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.21.0}
 */
export const STORE_MANAGEMENT = 'store-management';
export const MALL_MANAGEMENT = 'mall-stores-management-bundle';
export const B2B = 'b2b-bundle';
export const MAIN_DISTRIBUTOR = 'main-distributor-bundle';
export const DISTRIBUTOR = 'distributor-bundle';
export const SHOPIFY = 'shopify-bundle';
export const AFFILIATE = 'affiliate-bundle';
